/**
 * Block: simple-map
 *
 * Interactive world map with country hover tooltips. Each country group
 * (`g[data-group]` inside `svg#simple-map`) shows a tooltip with one or
 * more flag images and a country label on hover. Tooltip hides on scroll.
 *
 * The country flag SVGs live alongside the block (`assets/svg/image-{n}.svg`).
 * The block's `<section>` exposes a `data-template-uri` attribute pointing
 * at the theme template directory so we can build flag image URLs without
 * a global $globals object.
 */

const definitions = [
    { id: 1, label: 'Mexico', images: [2] },
    { id: 2, label: 'Portugal', images: [2] },
    { id: 3, label: 'Spain', images: [2] },
    { id: 4, label: 'Switzerland', images: [2] },
    { id: 5, label: 'Germany', images: [2] },
    { id: 6, label: 'United Kingdom', images: [2] },
    { id: 7, label: 'France', images: [2] },
    { id: 8, label: 'Brazil', images: [2] },
    { id: 9, label: 'Curaçao', images: [1] },
    { id: 10, label: 'Dominican Republic', images: [1] },
    { id: 11, label: 'Puerto Rico', images: [1] },
    { id: 12, label: 'Panama', images: [1, 2] },
    { id: 13, label: 'Venezuela', images: [1, 2] },
    { id: 14, label: 'Florida', images: [1, 2] },
];

function getDefinition(id, templateUri) {
    const def = definitions.find((d) => d.id === id);
    if (!def) return '';

    const imgs = def.images
        .map((n) => `<img src="${templateUri}/blocks-general/simple-map/assets/svg/image-${n}.svg" alt="">`)
        .join('');

    return `<div class="html">${imgs}<span>${def.label}</span></div>`;
}

function initMap(section) {
    const svg = section.querySelector('svg#simple-map');
    const tooltip = section.querySelector('.map .tooltip');
    if (!svg || !tooltip) return;

    const templateUri = section.dataset.templateUri || '';
    const groups = svg.querySelectorAll('g[data-group]');
    if (!groups.length) return;

    function hideTooltip() {
        groups.forEach((g) => g.classList.remove('is-hovered'));
        tooltip.classList.remove('is-visible');
    }

    groups.forEach((group) => {
        group.addEventListener('mouseenter', (e) => {
            e.preventDefault();
            e.stopPropagation();

            if (group.classList.contains('is-hovered')) return;

            const id = parseInt(group.getAttribute('data-group'), 10);
            tooltip.innerHTML = getDefinition(id, templateUri);

            // Position relative to viewport (tooltip is position: fixed)
            const rect = group.getBoundingClientRect();
            const tipX = rect.x + rect.width / 2 - tooltip.offsetWidth / 2;
            const tipY = rect.y - tooltip.offsetHeight;

            tooltip.style.top = `${tipY}px`;
            tooltip.style.left = `${tipX}px`;

            groups.forEach((g) => g.classList.remove('is-hovered'));
            group.classList.add('is-hovered');

            tooltip.classList.add('is-visible', 'has-effects');
        });

        group.addEventListener('mouseleave', hideTooltip);
    });

    // Hide tooltip on scroll
    window.addEventListener('scroll', hideTooltip);
}

export function init() {
    const sections = document.querySelectorAll('section.simple-map');
    sections.forEach(initMap);
}
